module.exports = __webpack_public_path__ + "img/product1.c9b73f64.png";